import * as actionTypes from './actionTypes';
import axios from 'axios';

export const fetchDocumentsSuccess = ( documents ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTS_SUCCESS,
        documents: documents
    };
};

export const fetchDocumentsFail = ( error ) => {
    return {
        type: actionTypes.FETCH_DOCUMENTS_FAIL,
        error: error
    };
};

export const fetchDocumentsStart = () => {
    return {
        type: actionTypes.FETCH_DOCUMENTS_START
    };
};

export const fetchDocuments = (token, userId) => {
    return dispatch => {
        dispatch(fetchDocumentsStart());
        let site = window.location.hostname;
        site = site.replace('mulch','');
        if (site === '') {
            site = 'local';
        }

        axios.get('https://api.mescout.org/api/MulchOrder/GetDocuments?site=' + site)
            .then( res => {
                const fetchedDocuments = [];
                for ( let key in res.data ) {
                    fetchedDocuments.push( {
                        ...res.data[key],
                        id: key
                    } );
                }
                dispatch(fetchDocumentsSuccess(fetchedDocuments));
            } )
            .catch( err => {
                dispatch(fetchDocumentsFail(err));
            } );
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/documents.js